// extracted by mini-css-extract-plugin
module.exports = {"main":"Loading_main__1YHLH"};